import axios from 'axios'

const strapi = axios.create({
  baseURL: import.meta.env.VITE_APP_STRAPI_URL || 'https://strapi.cannect.life/api'
})

export default strapi
